import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import { Container, Row, Col, Button, Form, Input } from 'reactstrap';
import Swiper from 'react-id-swiper';
import * as vars from '../../constants/constants';
import { messages } from '../../constants/messages';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { getVideoOrChannelRelatedData } from '../../actions/PlayActions';
import { addFavoriteVideo, addLikesVideos, addFavoriteChannel, addLikesChannels } from '../../actions/FavoriteActions';
import { getDetails, getInterests } from '../../actions/AccountActions';
import { addVideoHistory, addChannelHistory } from '../../actions/HistoryActions';
import { showMessage } from '../../actions/FlashMessageActions';
import { setHeaderTitle } from '../../actions/HeaderActions';
import { console_log, parseQueryString } from '../../utils/helper';
import VideoPlayer from './VideoPlayer';
import getAllDataHOC from './../../containers/getAllDataHOC'
import { FormattedMessage } from 'react-intl';
import { config } from '../../constants/domainConfig';
import { sendData } from '../../analytics/sendData';
import WarningModal from './WarningModal'
import DownloadBtn from '../DownloadBtn/DownloadBtn';


class PlayVideo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isRTL: false,
            data: {},
            isPlaying: false,
            playUrl: '',
            showWarning: /iPhone|iPad|iPod/i.test(navigator.userAgent)
        };

        this.getVideoCategories = this.getVideoCategories.bind(this);
        this.getVideoFromVideoId = this.getVideoFromVideoId.bind(this);
        this.addRemoveFavorite = this.addRemoveFavorite.bind(this);
        this.isVideoFavorite = this.isVideoFavorite.bind(this);
        this.playVideo = this.playVideo.bind(this);
        this.getVideo = this.getVideo.bind(this);
        this.goToPlay = this.goToPlay.bind(this);
        this.addHistoryVideo = this.addHistoryVideo.bind(this);
        this.addLike = this.addLike.bind(this);
        this.isVideoLiked = this.isVideoLiked.bind(this);
        this.hideModal = this.hideModal.bind(this);
    }

    componentWillMount() {

        let selectedVideo;
        let play = sessionStorage.getItem("mobiotv") ? JSON.parse(sessionStorage.getItem("mobiotv")).CategoryReducer : null
        if (play !== null) {
            selectedVideo = this.getVideoFromVideoId(parseInt(parseQueryString(this.props.location.search)['vid']));
        }
        if (selectedVideo) {
            this.props.setHeaderTitle(selectedVideo.name[config.lang] ? selectedVideo.name[config.lang] : selectedVideo.name['en']);
            this.getVideoCategories(selectedVideo.id);
        }
        window.addEventListener('resize', () => this.toggleVideoDescription());
        window.addEventListener('orientationchange', () => this.isLandscape());
    }

    shouldComponentUpdate() {
        return true;
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.state.isPlaying && prevState.data.video.name != this.state.data.video.name) sendData(this.state.data.video.name, this.state.data.category.categoryName['en'], 'video', 'viewed');
        this.toggleVideoDescription();
    }

    disposeVideoPlayer() {
        this.setState({
            isPlaying: false
        })
    }

    componentDidMount() {
        sendData(this.state.data.video.name, this.state.data.category.categoryName['en'], 'video', 'viewed');
        document.body.classList.add("play-page");
        window.scrollTo(0, 1);
        // this.getVideo(this.props.play.data.video.id);
        this.toggleVideoDescription();
        this.isLandscape();
    }

    toggleVideoDescription() {
        let videoDescButtonWrap = document.querySelector(".video__desc__btn-wrap");
        let videoDesc = document.querySelector(".video__desc");
        let videoDetailsWrap = document.querySelector(".video__details__wrap");
        let videoDescButton = document.querySelector(".video__desc__btn");
        let relatedSlide = document.querySelector(".related-slide");
        if (window.innerWidth <= 575) {
            if (videoDesc.scrollHeight > 75) {
                videoDescButtonWrap.style.opacity = "1";
                videoDescButtonWrap.style.height = "auto";
                videoDescButtonWrap.style.width = "100%";
            } else {
                videoDescButtonWrap.style.opacity = "0";
                videoDescButtonWrap.style.height = "0";
                videoDescButtonWrap.style.width = "0";
            }
        } else {
            videoDescButtonWrap.style.opacity = "0";
            videoDescButtonWrap.style.height = "0";
            videoDescButtonWrap.style.width = "0";
        }
        videoDetailsWrap.addEventListener("click", function (e) {
            if (e.target.className === "video__desc__btn") {
                videoDesc.classList.toggle("video__desc--more");
                if (videoDesc.classList.contains("video__desc--more")) {
                    videoDesc.style.maxHeight = videoDesc.scrollHeight + "px";
                    videoDescButton.textContent = "Show Less";
                } else {
                    videoDesc.style.maxHeight = "";
                    videoDescButton.textContent = "Show More";
                }
            }
        })
        if(relatedSlide){
            relatedSlide.addEventListener("click", function (e) {
                if (e.target.className !== "heart-fill") {
                    if (videoDesc.classList.contains("video__desc--more")) {
                        videoDesc.classList.toggle("video__desc--more");
                        videoDesc.style.maxHeight = "";
                        videoDescButton.textContent = "Show More";
                    }
                }
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        this.toggleVideoDescription();
    }

    componentWillUnmount() {
        document.body.classList.remove("play-page");
        window.removeEventListener('resize', () => this.toggleVideoDescription());
        window.removeEventListener('orientationchange', () => this.isLandscape());
        if (this.player) {
            this.player.dispose()
        }
    }

    getVideoFromVideoId(videoId) {
        let categories = sessionStorage.getItem("mobiotv") ? JSON.parse(sessionStorage.getItem("mobiotv")).CategoryReducer : null;
        let foundCategory = categories.videos.find((cat) => {
            let videoIds = cat.videos.map(v => v.id);
            if (~videoIds.indexOf(videoId)) return cat;
        });
        if (foundCategory) {
            return foundCategory.videos.find(v => v.id == videoId);
        }
        return null;
    }
    getVideoCategories(videoId) {
        let category = sessionStorage.getItem("mobiotv") ? JSON.parse(sessionStorage.getItem("mobiotv")).CategoryReducer : null
        let videoCategory = category.videos.find((category) => {
            let videoIds = category.videos.map(v => v.id);
            if (~videoIds.indexOf(videoId)) {
                return category;
            }
        });
        if (videoCategory) {
            let video = videoCategory.videos.find((v) => v.id == videoId);
            this.setState({
                data: Object.assign({ video: video }, { category: videoCategory })
            });
        } else {
            this.props.history.goBack();
        }
    }

    isVideoFavorite(videoId) {
        let indexOf = this.props.favorite.videos.findIndex((f) => {
            return f.videoId == videoId;
        });

        if (indexOf != -1) {
            return true;
        }
        return false;
    }

    addRemoveFavorite(video, event) {
        event.preventDefault();
        if (event.target.tagName == 'path' || event.target.classList.contains('favoriteClick')) {
            this.videoFavorite(video);
        }
    }

    videoFavorite(video) {
        let favoriteVideos = this.props.favorite.videos;
        let indexOf = favoriteVideos.findIndex((f) => {
            return f.videoId == video.id;
        });
        let videoToBeUpdated = {
            videoId: video.id,
            duration: video.duration,
            name: video.name[config.lang == 'pt' ? 'en' : config.lang],
            preview: video.preview
        };

        if (indexOf == -1) {
            this.props.showMessage({
                message: messages[config.lang].addToFavorites,
                type: true
            });
            favoriteVideos.push(videoToBeUpdated);
            axios.post(vars.BASE_API_URL + "/favorites/videos", videoToBeUpdated)
                .then((response) => {
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        } else {
            this.props.showMessage({
                message: messages[config.lang].removeFromFavorites,
                type: false
            });
            favoriteVideos.splice(indexOf, 1);
            axios.delete(vars.BASE_API_URL + "/favorites/videos/" + videoToBeUpdated.videoId)
                .then((response) => {
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        }

        this.props.addFavoriteVideo(favoriteVideos);
    }

    isMobile() {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }

    isIos() {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    }

    isLandscape() {
        return (window.orientation === 90 || window.orientation === -90);
    }

    iosHideAddressBar() {
        let isMobile = this.isMobile();
        let isIos = this.isIos();
        let isLandscape = this.isLandscape();
        if (isMobile && isIos && isLandscape) {
            let currentScrollPosition = window.scrollY;
            window.scrollBy(0, currentScrollPosition + 1);
        }
    }

    playVideo() {
        this.setState({
            isPlaying: !this.state.isPlaying
        });
        this.addHistoryVideo(this.state.data.video);
    }

    getVideo(videoId) {

    }

    goToPlay(data, event) {

        event.preventDefault();
        if (event.target.tagName == 'path' || event.target.classList.contains('favoriteClick')) {
            this.videoFavorite(data.video);
        } else {
            window.scrollTo(0, 0);
            this.props.history.push(`/play/video/?vid=${data.video.id}&uid=${this.props.account.user.uid}`)
            this.getVideo(data.video.id);
            this.props.setHeaderTitle(data.video.name[config.lang] ? data.video.name[config.lang] : data.video.name['en']);
            this.getVideoCategories(data.video.id);
            this.props.getVideoOrChannelRelatedData(data);
        }
        this.disposeVideoPlayer();
    }

    addHistoryVideo(video) {
        let historyVideos = this.props.historyVideos.videos;
        let indexOf = historyVideos.findIndex((f) => {
            return f.videoId == video.id;
        });
        let videoToBeUpdated = {
            videoId: video.id,
            duration: video.duration,
            name: video.name[config.lang == 'pt' ? 'en' : config.lang],
            preview: video.preview
        };

        if (indexOf == -1) {
            historyVideos.push(videoToBeUpdated);
            axios.post(vars.BASE_API_URL + "/history/videos", videoToBeUpdated)
                .then((response) => {
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        }

        this.props.addVideoHistory(historyVideos);
    }

    addLike(video, event) {
        event.preventDefault();
        this.videoLike(video);
    }

    videoLike(video) {
        let likedVideos = this.props.favorite.videosLiked;
        let indexOf = likedVideos.findIndex((f) => {
            return f.videoId == video.id;
        });

        let videoToBeUpdated = {
            videoId: video.id,
            duration: video.duration,
            name: video.name[config.lang == 'pt' ? 'en' : config.lang],
            preview: video.preview
        };

        if (indexOf == -1) {
            likedVideos.push(videoToBeUpdated);
            axios.post(vars.BASE_API_URL + "/likes/videos", videoToBeUpdated)
                .then((response) => {
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        } else {
            likedVideos.splice(indexOf, 1);
            axios.delete(vars.BASE_API_URL + "/likes/videos/" + videoToBeUpdated.videoId)
                .then((response) => {
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        }

        this.props.addLikesVideos(likedVideos);
    }

    isVideoLiked(videoId) {
        let indexOf = this.props.favorite.videosLiked.findIndex((f) => {
            return f.videoId == videoId;
        });

        if (indexOf != -1) {
            return true;
        }
        return false;
    }

    hideModal() {
        this.setState({
            showWarning: false
        })
    }

    render() {
        const sliderData = {
            slidesPerView: 'auto',
            speed: 400,
            spaceBetween: 30,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                767: {
                    direction: 'vertical',
                    slidesPerView: 'auto',
                    speed: 400,
                    spaceBetween: 0,
                    touchReleaseOnEdges: true,
                }
            }
        },
            heartIcon = '<svg class="favoriteClick" xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewbox="0 0 70 70" preserveAspectRatio="none"><path d="M66.43 20.39c-.93-10.37-8.21-17.9-17.32-17.9a17.224 17.224 0 0 0-14.76 8.57 16.588 16.588 0 0 0-14.4-8.57c-9.11 0-16.39 7.52-17.33 17.9a18.807 18.807 0 0 0 .55 6.8 29.14 29.14 0 0 0 8.86 14.91l22.31 20.41L57.02 42.1a29.227 29.227 0 0 0 8.87-14.91 18.412 18.412 0 0 0 .54-6.8z" data-name="fave ico" class="heart-fill"/></svg>',
            heartIconNoBg = '<svg class="favoriteClick" xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewbox="0 0 70 70" preserveAspectRatio="none"><path d="M66.43 20.39c-.93-10.37-8.21-17.9-17.32-17.9a17.224 17.224 0 0 0-14.76 8.57 16.588 16.588 0 0 0-14.4-8.57c-9.11 0-16.39 7.52-17.33 17.9a18.807 18.807 0 0 0 .55 6.8 29.14 29.14 0 0 0 8.86 14.91l22.31 20.41L57.02 42.1a29.227 29.227 0 0 0 8.87-14.91 18.412 18.412 0 0 0 .54-6.8z" data-name="fave ico" class="heart-fill"/></svg>',
            thumbsUpIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 456.814 456.814"><g class="thumbs-fill"><path d="M441.11 252.677c10.468-11.99 15.704-26.169 15.704-42.54 0-14.846-5.432-27.692-16.259-38.547-10.849-10.854-23.695-16.278-38.541-16.278h-79.082c.76-2.664 1.522-4.948 2.282-6.851.753-1.903 1.811-3.999 3.138-6.283 1.328-2.285 2.283-3.999 2.852-5.139 3.425-6.468 6.047-11.801 7.857-15.985 1.807-4.192 3.606-9.9 5.42-17.133 1.811-7.229 2.711-14.465 2.711-21.698 0-4.566-.055-8.281-.145-11.134-.089-2.855-.574-7.139-1.423-12.85-.862-5.708-2.006-10.467-3.43-14.272-1.43-3.806-3.716-8.092-6.851-12.847-3.142-4.764-6.947-8.613-11.424-11.565-4.476-2.95-10.184-5.424-17.131-7.421-6.954-1.999-14.801-2.998-23.562-2.998-4.948 0-9.227 1.809-12.847 5.426-3.806 3.806-7.047 8.564-9.709 14.272-2.666 5.711-4.523 10.66-5.571 14.849-1.047 4.187-2.238 9.994-3.565 17.415-1.719 7.998-2.998 13.752-3.86 17.273-.855 3.521-2.525 8.136-4.997 13.845-2.477 5.713-5.424 10.278-8.851 13.706-6.28 6.28-15.891 17.701-28.837 34.259-9.329 12.18-18.94 23.695-28.837 34.545-9.899 10.852-17.131 16.466-21.698 16.847-4.755.38-8.848 2.331-12.275 5.854-3.427 3.521-5.14 7.662-5.14 12.419v183.01c0 4.949 1.807 9.182 5.424 12.703 3.615 3.525 7.898 5.38 12.847 5.571 6.661.191 21.698 4.374 45.111 12.566 14.654 4.941 26.12 8.706 34.4 11.272 8.278 2.566 19.849 5.328 34.684 8.282 14.849 2.949 28.551 4.428 41.11 4.428h36.831c25.321-.38 44.061-7.806 56.247-22.268 11.036-13.135 15.697-30.361 13.99-51.679 7.422-7.042 12.565-15.984 15.416-26.836 3.231-11.604 3.231-22.74 0-33.397 8.754-11.611 12.847-24.649 12.272-39.115.024-6.097-1.4-13.328-4.261-21.706zM100.5 191.864H18.276c-4.952 0-9.235 1.809-12.851 5.426C1.809 200.905 0 205.188 0 210.137v182.732c0 4.942 1.809 9.227 5.426 12.847 3.619 3.611 7.902 5.421 12.851 5.421H100.5c4.948 0 9.229-1.81 12.847-5.421 3.616-3.62 5.424-7.904 5.424-12.847V210.137c0-4.949-1.809-9.231-5.424-12.847-3.617-3.618-7.898-5.426-12.847-5.426zM67.665 369.308c-3.616 3.521-7.898 5.281-12.847 5.281-5.14 0-9.471-1.76-12.99-5.281-3.521-3.521-5.281-7.85-5.281-12.99 0-4.948 1.759-9.232 5.281-12.847 3.52-3.617 7.85-5.428 12.99-5.428 4.949 0 9.231 1.811 12.847 5.428 3.617 3.614 5.426 7.898 5.426 12.847 0 5.14-1.805 9.468-5.426 12.99z"/></g></svg>',
            smartTvIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 72.6 72.6"><circle class="smart-tv-circle" cx="36.3" cy="36.3" r="34.3"/><path class="smart-tv-path" d="M48.9 29H31.2c-1.1 0-2-.9-2-2v-.8c0-1.1.9-2 2-2h17.7c1.1 0 2 .9 2 2v.8c0 1.1-.9 2-2 2zM49.1 38.9H31.4c-1.1 0-2-.9-2-2V36c0-1.1.9-2 2-2h17.7c1.1 0 2 .9 2 2v.8c0 1.2-.9 2.1-2 2.1zM48.9 48.9H31.2c-1.1 0-2-.9-2-2V46c0-1.1.9-2 2-2h17.7c1.1 0 2 .9 2 2v.8c0 1.2-.9 2.1-2 2.1zM26.4 25.9l-4.1-2.7c-.4-.2-.9 0-.9.5V29c0 .4.5.7.9.5l4.1-2.7c.3-.1.3-.6 0-.9zM26.4 36.5l-4.1-2.7c-.4-.2-.9 0-.9.5v5.3c0 .4.5.7.9.5l4.1-2.7c.3-.2.3-.7 0-.9zM26.4 45.7L22.3 43c-.4-.2-.9 0-.9.5v5.3c0 .4.5.7.9.5l4.1-2.7c.3-.2.3-.7 0-.9z"/></svg>';

        let allData = this.state.data;
        return (
            <section className={this.state.isPlaying ? "play play-bg pb-0 video-active" : "play play-bg pb-0"}>
                {config.domain === 'no' ? <WarningModal open={this.state.showWarning} onClose={this.hideModal} /> : null}
                <Row>
                    <Col xs="12">
                        {allData ?
                            <div className={this.state.isRTL ? "ar" : ""}>
                                <div className="video">

                                    {(this.state.isPlaying) ?
                                        <VideoPlayer videoUrl={allData.video.videoUrl} videoTitle={this.state.data.video.name} videoCategory={this.state.data.category.categoryName['en']} />
                                        :
                                        <div>
                                            <div className="play__thumb-wrap">
                                                <img className="play__thumb" src={allData.video.preview} alt={allData.video.name[config.lang == 'pt' || config.lang == 'de' ? 'en' : config.lang]} />
                                            </div>
                                            <div className="play__btn-wrap">
                                                <a className="common-btn common-btn--red play__btn" href="javascript:void(0);" onClick={this.playVideo}>
                                                    <span className="play__btn-inner">
                                                        <i className="fa fa-play" aria-hidden="true"></i>
                                                        <span className="play__btn-text" style={{paddingRight: 10 +'px'}}>
                                                            <FormattedMessage id="play"
                                                                defaultMessage="Play"
                                                            />
                                                        </span>
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    }
                                    <div className="video__details__wrap">
                                        <div className="video__details">
                                            <div className="video__head">
                                                <h3 className="video__title">{allData.video.name[config.lang] ? allData.video.name[config.lang] : allData.video.name['en']}</h3>
                                                <div className="video__head__ratings">
                                                    <div className="video__fav favoriteClick" style={config.dir=='rtl'? {paddingLeft: 10 + 'px'}:{}} onClick={this.addRemoveFavorite.bind(this, allData.video)}>
                                                        <input className="icon-toggle favoriteClick" id="two" type="checkbox" checked={this.isVideoFavorite(allData.video.id)} onChange={() => { }} />
                                                        <label className="icon-toggle-label favoriteClick" htmlFor="two">
                                                            <span className="no-bg favoriteClick"><i className="fa fa-star favoriteClick" aria-hidden="true"></i></span>
                                                        </label>
                                                        <span className="video__star__text">
                                                            <FormattedMessage id="favorite"
                                                                defaultMessage="Favorite"
                                                            />
                                                        </span>
                                                    </div>
                                                    <div className="video__rate" onClick={this.addLike.bind(this, allData.video)}>
                                                        <input className="icon-toggle" id="three" type="checkbox" checked={this.isVideoLiked(allData.video.id)} onChange={() => { }} />
                                                        <label className="icon-toggle-label" htmlFor="three">
                                                            <span className="no-bg" dangerouslySetInnerHTML={{ __html: thumbsUpIcon }} />
                                                        </label>
                                                        <span className="video__star__text">
                                                            <FormattedMessage id="rate"
                                                                defaultMessage="Rate"
                                                            />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                (config.domain === 'fr' || config.domain === 'lu') && <DownloadBtn videoUrl = {allData.video.videoUrl.replace('https://cdn.mobio360.com/','https://cdn.mobio360.com/download/')}/>
                                            }
                                            <div className="video__sub-head">
                                                <div className="imdb">
                                                    {/*<img className="imdb__image" src="./img/imdb.png" alt="IMDB" />*/}
                                                    {/*<span className="imdb__rating">{((Math.random() * 10) + 1).toFixed(1)} / 10</span>*/}
                                                </div>
                                                {/* <div className="video__extras">
                                                    <ul className="list-unstyled video__extras__list">
                                                        <li className="video__extras__item"><span className="video__extras__text">PG-13</span></li>
                                                        <li className="video__extras__item"><span className="video__extras__text">2h 6min</span></li>
                                                        <li className="video__extras__item"><span className="video__extras__text">15 August 2014 (USA)&#x200E;</span></li>
                                                    </ul>
                                                    <div className="video__genre">
                                                        <img src="./img/tag-icon.png" alt="genre" />
                                                        <span className="video__genre__text">{(video.category) ? video.category.name : ''}</span>
                                                    </div>
                                                </div> */}
                                            </div>
                                            <p className={this.state.isRTL ? "video__desc text-reverse" : "video__desc"}>{(allData.video.desc && typeof allData.video.desc === 'object') ? (allData.video.desc[config.lang] || allData.video.desc['en'] || allData.video.name[config.lang == 'pt' || config.lang == 'de' ? 'en' : config.lang]) : (allData.video.desc || allData.video.name[config.lang == 'pt' || config.lang == 'de' ? 'en' : config.lang])}</p>
                                            <div className="video__desc__btn-wrap">
                                                <button className="btn-unstyled video__desc__btn">
                                                    <FormattedMessage id="showMore"
                                                        defaultMessage="Show More"
                                                    />
                                                </button>
                                            </div>
                                            <ul className="list-unstyled video__cast">
                                                <li className="video__cast__item"><span className="video__cast__title">
                                                    <FormattedMessage id="director"
                                                        defaultMessage="Director:"
                                                    /> </span><span className="video__cast__text">NA</span></li>
                                                <li className="video__cast__item"><span className="video__cast__title">
                                                    <FormattedMessage id="writers"
                                                        defaultMessage="Writers:"
                                                    /> </span><span className="video__cast__text">NA</span></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : ""
                        }
                    </Col>
                </Row>
                <Container fluid>
                    <Row>
                        <Col xs="12">
                            {allData.category ?
                                <div className="related-wrap">
                                    <div className="category-head related-top-links">
                                        <h3 className="primary-text">
                                            <FormattedMessage id="relatedVids"
                                                defaultMessage="Related Videos"
                                            />
                                        </h3>
                                        <div className="category-head__favorite">
                                            <h3 style={config.dir=='rtl' ?{paddingLeft: 10 +'px'}:{}}>
                                                <FormattedMessage id="autoplay"
                                                    defaultMessage="Autoplay"
                                                />
                                            </h3>
                                            <label className="switch">
                                                <input type="checkbox" className="switch__checkbox" />
                                                <span className="switch__slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div>
                                        {allData.category.videos.length > 0 ?
                                            <Swiper {...sliderData} rebuildOnUpdate={false} shouldSwiperUpdate={true}>
                                                {allData.category.videos.map((v) => {
                                                    if (v.id != allData.video.id) {
                                                        return (
                                                            <div key={v.id} className="related-slide" onClick={this.goToPlay.bind(this, { video: v, category: allData.category.id })}>
                                                                <div className="channels-thumb channels-thumb--genre">
                                                                    <div className="channels-image channels-image--genre no-radius">
                                                                        <img className="channels-thumb__image channels-thumb__image--genre rounded-0" src={v.preview} alt={v.name[config.lang == 'pt' ? 'en' : config.lang]} />
                                                                    </div>
                                                                    <div className="channels-thumb__fav " style={config.lang==='ar'? {left:"-230%"}:{}}>
                                                                        <input className="icon-toggle favoriteClick" id={'vod-' + v.id} type="checkbox" checked={this.isVideoFavorite(v.id)} onChange={() => { }} />
                                                                        <label className="icon-toggle-label favoriteClick" htmlFor={'vod-' + v.id}>
                                                                            <span className="favoriteClick"><i className="fa fa-star favoriteClick" aria-hidden="true"></i></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div className="channels-thumb__details channels-thumb__details--related">
                                                                    <div className="channels-thumb__inner channels-thumb__inner--related">
                                                                        <div className="channels-thumb__name channels-thumb__name--related">
                                                                            {v.name[config.lang] ? v.name[config.lang] : v.name['en']}
                                                                            {/*  <span className="channel-show__name"><img className="related-live-icon" src="./img/play.svg" /> {v.duration}</span> */}
                                                                            {/* <span className="channel-show__name">{v.duration}</span>                                                                         */}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                })}
                                            </Swiper>
                                            : ''}
                                    </div>
                                </div>
                                : ''
                            }
                        </Col>
                    </Row>
                </Container>
            </section>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        getVideoOrChannelRelatedData,
        addFavoriteChannel,
        addFavoriteVideo,
        showMessage,
        setHeaderTitle,
        getDetails,
        addLikesChannels,
        addLikesVideos,
        getInterests,
        addVideoHistory,
        addChannelHistory
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayVideo);


// WEBPACK FOOTER //
// ./src/components/Play/PlayVideo.js